import { Directive, ElementRef, Input, OnDestroy, booleanAttribute, inject } from '@angular/core';

@Directive({
  selector: '[scrollIntoView]',
  standalone: false
})
export class ScrollIntoViewDirective implements OnDestroy {
  private host = inject<ElementRef<HTMLElement>>(ElementRef);
  private animationFrameId?: number;

  @Input({ transform: booleanAttribute }) set scrollIntoView(shouldScroll: boolean) {
    shouldScroll
      ? this.scheduleScroll()
      : this.cancelScheduledScroll();
  }

  ngOnDestroy(): void {
    this.cancelScheduledScroll();
  }

  private scheduleScroll(): void {
    this.cancelScheduledScroll();
    this.animationFrameId = requestAnimationFrame(() => {
      this.host.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      this.animationFrameId = undefined;
    });
  }

  private cancelScheduledScroll(): void {
    if (!this.animationFrameId) {
      return;
    }

    cancelAnimationFrame(this.animationFrameId);
    this.animationFrameId = undefined;
  }
}
